// DraggableSurgeryBar.js - スマホ対応改善版
import React, { useRef } from 'react';
import { useDrag } from 'react-dnd';

const DraggableSurgeryBar = ({ 
  surgery, 
  quarter, 
  room, 
  durationMinutes, 
  onClick, 
  onDropSuccess, 
  children, 
  className 
}) => {
  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: 'surgery',
    item: () => ({
      docId: surgery.docId,
      surgery,
      quarter,
      room,
      durationMinutes,
      originalRoom: room,
      originalTime: surgery.start
    }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      if (monitor.didDrop()) {
        onDropSuccess?.();
      }
    },
  });

  drag(ref);

  // ドラッグ中のスタイル
  const dragStyle = {
    opacity: isDragging ? 0.5 : 1,
    transform: isDragging ? 'rotate(2deg)' : 'none',
    cursor: 'grab',
  };

  return (
    <div
      ref={ref}
      className={`draggable-surgery-bar ${className || ''}`}
      style={dragStyle}
      onClick={onClick}
      onTouchStart={(e) => {
        // タッチ開始時の視覚的フィードバック
        e.currentTarget.style.transform = 'scale(1.02)';
        // バイブレーション（対応デバイスのみ）
        if (navigator.vibrate) {
          navigator.vibrate(50);
        }
      }}
      onTouchEnd={(e) => {
        // タッチ終了時のスタイルリセット
        e.currentTarget.style.transform = '';
      }}
      onTouchCancel={(e) => {
        // タッチキャンセル時のスタイルリセット
        e.currentTarget.style.transform = '';
      }}
    >
      {children}

      {/* ドラッグハンドル（タッチ用） */}
      <div className="drag-handle">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
        </svg>
      </div>
    </div>
  );
};

export default DraggableSurgeryBar;